export default __webpack_public_path__ + "static/media/poor.939f567f.jpg";